import appconfig from '../src/appconfig';
import logger from '../src/logger';
import { expose, getTarget } from '../src/rpc';
import { IframeBuilder } from './iframe.ts';

import {
  createScriptTag,
  devStyleInject,
  enterFailsafe,
  extractIds,
  injectDiv,
  injectTag,
  isFunction,
  parseScriptTagUrl,
  /* preloadFont, */
  setStyles,
} from './helper';
import {
  mainContainerStyles,
  portalFrameStyles,
} from './loader-styles';


const legacyClients = [
  '3ed4453af983019fa5e2ae6a1c061671e8c93f551b2223949e815493b0a41cbe', //unilabs hcps
  '3ed4453af983019fa5e2ae6a1c061671e8c93f551b2223949e815493b0a41cbe-it', //unilabs hcps
];



// Don't use SRI on development -> it will break and won't work

let widgetframe;

// APIhandler
let apiOnHandler = {};
// we might already have a config object insode of window.moin so we copy it to make sure
// the object is present and we don't overrride the config
window.moin = Object.assign({}, window.moin);
window.knowhere = {};
window.knowhere.api = {};

const mountLegacyClient = (url) => {
  logger.log('mount legacy widget');
  try {
    const scriptUrl = url.replace('moin-loader.js', 'kn-widget-loader.js');
    const tag = createScriptTag('knw-botscript', scriptUrl);
    injectTag(document.getElementsByTagName('head')[0], tag);
  } catch {
    // TODO enter fail safe
  }
};

const mountWidget = async ({ botId, channelId, basePath }) => {

  /*   preloadFont(
      document.head,
      `${basePath}/fonts/rubik-v9-latin-500.woff2`,
      appconfig.useSRI ? appconfig.sri.SRI_FONT_500 : null,
    );
    preloadFont(
      document.head,
      `${basePath}/fonts/rubik-v9-latin-regular.woff2`,
      appconfig.useSRI ? appconfig.sri.SRI_FONT_REG : null,
    ); */

  logger.log('loader | mount default widget', botId, channelId);


  // MAIN CONTAINER
  const mainContainer = injectDiv('moin-ai-container', document.body);
  setStyles(mainContainer, mainContainerStyles);

  const cssPath = appconfig.isDevelopment ? '' : basePath + '/main.css';
  const teaserFrameBuilder = new IframeBuilder('moin-ai-teaser', { title: 'Chat Gesprächseinstieg', name: 'moin-ai-teaser' })
    .addCSS({ id: 'moin-styles', href: cssPath, sri: appconfig.useSRI ? appconfig.sri.SRI_CSS : null })
    .addInnerBodyStyles(portalFrameStyles)
  await teaserFrameBuilder.injectInto(mainContainer)

  const buttonFrameBuilder = new IframeBuilder('moin-ai-button', { title: 'Starte neue Chat Konversation', name: 'moin-ai-button' })
    .addCSS({ id: 'moin-styles', href: cssPath, sri: appconfig.useSRI ? appconfig.sri.SRI_CSS : null })
    .addInnerBodyStyles(portalFrameStyles)
  await buttonFrameBuilder.injectInto(mainContainer)

  const widgetFrameBuilder = new IframeBuilder('moin-ai-widget', { title: 'Chatfenster', name: 'moin-ai-widget' })
    .addInnerAttribute('data-bot', botId)
    .addInnerAttribute('data-channel', channelId)
    .addInnerAttribute('data-width', window.innerWidth.toString())
    .addInnerAttribute('data-height', window.innerHeight.toString())
    .addCSS({ id: 'moin-styles', href: cssPath, sri: appconfig.useSRI ? appconfig.sri.SRI_CSS : null })
    .addScript({
      id: 'primus',
      src: appconfig.isDevelopment ? '/primus.js' : basePath + '/primus.js',
      sri: appconfig.useSRI ? appconfig.sri.SRI_PRIMUS : null,
    })
    .addScript({
      id: 'mainmoinjs',
      src: appconfig.isDevelopment ? '/src/main.ts' : basePath + '/main.js',
      type: appconfig.isDevelopment ? 'module' : null,
      sri: appconfig.useSRI ? appconfig.sri.SRI_MAIN : null,
    })
    .addInnerBodyStyles({
      margin: '0px',
      width: '100%',
      height: '100%',
    })
  widgetframe = await widgetFrameBuilder.injectInto(mainContainer)

};

const unmount = (options = {}, botId, channelId) => {
  const { preserveSession = false } = options;

  // call widget and unmount
  const rpc = getTarget({
    target: widgetframe.contentWindow,
  });
  rpc.call('unmount');

  // we need to wait here to make sure all connections are closed and all is porperly unmounted
  setTimeout(() => {
    // remove possible css vars
    try {
      document.body.style.removeProperty('--knowhere-vh');
      document.body.classList.remove('knowhere-ScrollLock');
      document.body.classList.remove('moin-scolllock');

      // remove div container and tags
      document.getElementById('moin-ai-teaser')?.remove();
      document.getElementById('moin-ai-button')?.remove();
      document.getElementById('moin-ai-widget')?.remove();
      document.getElementById('moin-ai-container')?.remove();
      document.getElementById('knw-botscript')?.remove();
      document.getElementById('moinloader')?.remove();

      // remove handler
      /* window.removeEventListener('message', postMessageHandler, false); */
    } catch (e) {
      logger.log('error removing widget', e);
    }
    // remove the .on handler for now
    apiOnHandler = {};

    // remove objects
    window.moin = null;
    window.knowhere = null;
    window.___moinloader = null;
    if (!preserveSession) {
      window.localStorage.removeItem(`knowhere_jwt_${botId}_${channelId}`);
      window.localStorage.removeItem('knowhere_widget_open');
    }
  }, 400);
};

const bindApiHandler = () => {
  const apiFunctions = [
    'addContext',
    'getContext',
    'toggle',
    'toggle_Widget',
    'close',
    'open',
    'typing',
    'alwaysOpen',
    'setThemeOption',
    'setWidgetzIndex',
    'showWidget',
    'hideWidget',
    'setPosition',
    'initLivechat',
    'getLivechatAvailable',
    'startLivechat',
    'stopLivechat',
    'teaser',
    'sendIntent',
    'clearQR',
    'setWidgetPosition',
    'setAlignmentOrigin',
  ];
  const rpc = getTarget({
    target: widgetframe.contentWindow,
  });

  apiFunctions.forEach((fn) => {
    window.moin[fn] = function () {
      return rpc.call(fn, arguments[0]);
    };
    window.knowhere.api[fn] = function () {
      console.warn('window.knowhere.api is deprecated, use window.moin');
      return rpc.call(fn, arguments[0]);
    };
  });
  // handle old legacy api calls with multiple parameter signature
  window.knowhere.api.setWidgetPosition = function () {
    console.warn(
      'window.knowhere.api is deprecated, use window.moin.setPosition instead',
    );
    var args = [];
    Array.prototype.push.apply(args, arguments);
    return rpc.call('setPosition', {
      bottom: args[0],
      right: args[1],
      unit: args[2],
    });
  };

  window.knowhere.api.setWidgetzIndex = function () {
    console.warn(
      'window.knowhere.api is deprecated, use window.moin.setWidgetzIndex instead',
    );
    var args = [];
    Array.prototype.push.apply(args, arguments);
    return rpc.call('setWidgetzIndex', { index: args[0] });
  };
};

// Expose event handler
const registerOnHandler = function (event, handler) {
  if (!Object.hasOwnProperty.call(apiOnHandler, event)) {
    apiOnHandler[event] = [];
  }
  apiOnHandler[event].push(handler);
};

const emitSignalToConsumer = (data) => {
  var eventType = data.signal;
  if (data.payload) {
    if (eventType && apiOnHandler[eventType]) {
      apiOnHandler[eventType].forEach(function (customerCallbackFunction) {
        customerCallbackFunction(data.payload);
      });
    }
  }
};

const callCustomerCode = () => {
  try {
    // calling "user" code after everything is ready and setup
    if (window.chatWidgetReady && isFunction(window.chatWidgetReady)) {
      window.chatWidgetReady();
    }
  } catch (error) {
    logger.log('error in chatWidgetReady function', error);
  }
};

const widgetSignaledReady = (args) => {
  logger.log(`the widget iframe called ready`, args.botId, args.channelId);
  // Initial host window resize
  const rpc = getTarget({
    target: widgetframe.contentWindow,
  });
  rpc.call('resize', {
    height: window.innerHeight,
    width: window.innerWidth,
  })
  callCustomerCode();
  window.moin.unmount = (options) => {
    unmount(options, args.botId, args.channelId);
  };
};

expose('widgetIsReady', (args) => widgetSignaledReady(args));
expose('signal', (args) => emitSignalToConsumer(args));

/* const postMessageHandler = (event) => {
  // TODO verify all signals are refactored to use the new signal system
  if (event.data.source === 'moin-widget' && event.data.command === 'signal') {
    console.error('postMessageHandler', 'THIS SHOULD NEVER APPEAR', event);
    emitSignalToConsumer(event.data);
  }
}; */


function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}
const init = async ({ mode, botId, channelId, url, basePath }) => {
  try {
    if (mode === 'legacy') {
      // QUESTION; DO WE NEED THE URL OVERRIDE HERE? I THINK YES
      // SO WE NEED TO PASS THE BOTID AND CHANNEL AND REBUILD THE URL?
      mountLegacyClient(url);
    } else {
      /* window.addEventListener('message', postMessageHandler, false); */
      await mountWidget({ botId, channelId, basePath });

      bindApiHandler();
      // EXPOSE PUBLIC FUNCS
      const rpc = getTarget({
        target: widgetframe.contentWindow,
      });
      const sendResizeEvent = () => {
        rpc.call('resize', {
          height: window.innerHeight,
          width: window.innerWidth,
        });
      }
      window.addEventListener('resize', debounce(sendResizeEvent, 50));



      // _> THIS NEED TO BE AN FUNCTION WITH EXPANDED OPTIONS
      // (botId, channelId, url) => { mountWidget({...options, botId, channelId, url})}
      window.moin.mount = () => {
        mountWidget({ botId, channelId, basePath });
      };
      window.moin.unmount = (options) => {
        unmount(options, botId, channelId);
      };

      window.moin.on = registerOnHandler;
      window.knowhere.api.on = registerOnHandler;
      // DEV ONLY to get css hot reload
      if (appconfig.isDevelopment) {
        devStyleInject();
      }
    }
  } catch (error) {
    enterFailsafe(error);
  }
};

if (window.___moinloader) {
  logger.warn('bot already loaded');
} else {
  try {
    window.___moinloader = true;
    window.moin = Object.assign({}, window.moin);
    logger.log('loader | start loading', appconfig);

    // NEED THE ID script Tag need the ID moinloader
    const selfscriptag =
      document.getElementById('moinloader') ||
      document.getElementById('knw-botscript') ||
      document.currentScript;

    if (!selfscriptag) throw new Error('Could not find script tag');

    const src = selfscriptag.getAttribute('src');
    const attrDelay = selfscriptag.getAttribute('data-loadingDelay');
    const urlInfo = parseScriptTagUrl(src);

    let delay = parseInt(attrDelay, 10) || 0;
    if (isNaN(delay)) {
      logger.warn('delay seems not to be a number, continue with zero delay');
      delay = 0;
    }

    const { botId, channelId } = extractIds(selfscriptag);
    const mode = legacyClients.includes(botId) ? 'legacy' : 'default';

    const options = {
      mode,
      botId,
      channelId,
      url: urlInfo.href,
      basePath: urlInfo.basePath,
      delay,
    };

    logger.log('loader | ', options, document.readyState);

    if (document.readyState === 'loading') {
      // if the page is still not loaded completly
      // we use the onload event to make sure we inject after everything else is loaded
      // so we do not influence (or as little as possible) the cls timings
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => init(options), delay);
      });
    } else {
      // if we are already in the "complete" state
      // we inject the script with delay that is given
      setTimeout(() => init(options), delay);
    }
  } catch (error) {
    logger.error('error in loader', error);
  }
}
